import { Link } from 'react-router-dom';
import { usePageMeta } from '../lib/site';

export default function NotFound() {
  usePageMeta('Page not found | MyGolfLinks', 'That page is not on the card.');

  return (
    <main>
      <section style={{ padding: 'clamp(160px, 20vw, 220px) 0 clamp(90px, 12vw, 140px)', textAlign: 'center' }}>
        <div className="wrap">
          <div className="mono" style={{ fontSize: 13, letterSpacing: '0.2em', color: 'var(--flag)', fontWeight: 600, margin: '18px 0 10px' }}>
            OB
          </div>
          <h1 className="h2">Out of bounds.</h1>
          <p className="lede" style={{ margin: '14px auto 30px' }}>
            That page isn't on the card. Drop back in play:
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" className="btn btn-line">Back to the first tee</Link>
            <Link to="/demo" className="btn btn-gold">Book a demo</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
